<app-data-grid-comp
    [columns]="columns"
    [gridDataResult]="employeesGridDataResult"
    [pageSize]="pageSize"
    [skip]="skip"
    category="Employees"
    [rowSelectionSettings]="{
        canSelectRows: true,
        selectableMode: 'multiple',
        selectRowBy: 'id'
    }"
    selectRowBy="employee"
    actionButtonText="Add"
    [isLoading]="isLoadingEmployees"
    [clearSelectedItems]="clearSelectedItems"
    searchable="true"
    export="customExcel"
    (emitExportEvent)="allData()"
    (emitSearchEvent)="search($event)"
    (emitPageChangeEvent)="pageChange($event)"
    (emitOpenDialogEvent)="showAddUserModal()"
    (emitDeleteEvent)="deleteAllSelected($event)"
></app-data-grid-comp>

<kendo-excelexport
    [data]="excelData"
    [fileName]="fileName"
    #excelexport
>
    <kendo-excelexport-column
        *ngFor="let column of excelColumns"
        [field]="column.field"
        [title]="column.title"
    >
    </kendo-excelexport-column>
</kendo-excelexport>